import React, { useCallback } from 'react'
import { useCopyToClipboard } from 'usehooks-ts'
import { CopySVG, CheckSVG } from 'src/components/Icons/Basic'
import { TooltipIconButton } from 'src/components/Reusable/Buttons/TooltipIconButton/TooltipIconButton'

export type ClipboardButtonProps = {
  text: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  light?: boolean
  preserveIconStyles?: boolean
  icon?: JSX.Element
}

export const ClipboardButton = ({
  text,
  placement = 'top',
  light = false,
  preserveIconStyles = false,
  icon,
}: ClipboardButtonProps): JSX.Element => {
  const [_, copy] = useCopyToClipboard()

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      e.stopPropagation()
      copy(text)
    },
    [copy, text],
  )

  return (
    <TooltipIconButton
      icon={icon || <CopySVG />}
      onClick={onClick}
      placement={placement}
      successIcon={<CheckSVG />}
      tooltipText="Copy"
      tooltipClickedText="Copied!"
      light={light}
      preserveIconStyles={preserveIconStyles}
    />
  )
}
